<template>
  <div class="educational-material-box">
    <wtr-educational-material-list
      :list="educationalMaterials"
      :options="{
        totalElements: totalMaterials,
        pagination: true,
        menuToggle: true,
      }"
      :params="paginationParams"
      :showLoader="loading || initialLoading"
      :tumorSites="tumorSites"
      :currentFolder="currentFolder"
      :subFilters="subFilters"
      :configSubFilters="configSubFilters"
      @filter-change="handleFilterChange"
      @create-new="openTypeSelector"
      @grid-mode="handleGridModeChange"
      @size-change="handleSizeChange"
      @page-change="handlePageChange"
    >
      <!-- List View (Table) -->
      <template v-slot:list-table>
        <b-table
          thead-class="bg-primary text-light"
          primary-key="id"
          outlined
          responsive
          hover
          :fields="tableFields"
          :items="educationalMaterials"
          show-empty
          empty-text="No educational materials found"
          :busy="loading"
          :sort-by.sync="paginationParams.sort"
          :sort-desc.sync="paginationParams.sortDesc"
        >
          <!-- Headers -->
          <template v-slot:head(type)="data">
           <div class="d-inline-flex align-items-center text-nowrap">
            <div class="text-nowrap">{{ data.label }}</div>
            <span class="cursor-pointer " v-on:click="handleSort('slide_collection_type')">
              &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
            </span>
            </div>
          </template>
          <template v-slot:head(idNumber)="data">
          <div class="d-inline-flex align-items-center text-nowrap">
            <div class="text-nowrap">{{ data.label }}</div>
            <span
              class="cursor-pointer"
              v-on:click="handleSort('system_id_number')"
            >
              &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
            </span>
            </div>
          </template>
          <template v-slot:head(tumorSite)="data">

            <div class="text-nowrap">{{ data.label }}</div>
          </template>
          <template v-slot:head(title)="data">
            <div class="d-inline-flex align-items-center text-nowrap">
              <div class="text-nowrap">{{ data.label }}</div>
              <span class="cursor-pointer" v-on:click="handleSort('title')">
                &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
              </span>
            </div>
          </template>
          <template v-slot:head(difficultyLevel)="data">
            <div class="d-inline-flex align-items-center text-nowrap">
              <div class="text-nowrap">{{ data.label }}</div>
              <span
                class="cursor-pointer"
                v-on:click="handleSort('difficulty_level')"
              >
                &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
              </span>
            </div>
          </template>
          <template v-slot:head(createdDateTime)="data">
            <div class="d-inline-flex align-items-center text-nowrap">
              <div class="text-nowrap">{{ data.label }}</div>

              <span class="cursor-pointer" v-on:click="handleSort('createdDate')">
                &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
              </span>
            </div>
          </template>
          <template v-slot:head(authors)="data">
            <div class="d-inline-flex align-items-center text-nowrap">
              <div class="text-nowrap">{{ data.label }}</div>
              <span class="cursor-pointer" v-on:click="handleSort('u.first_name')">
                &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
              </span>
            </div>
          </template>
          <template v-slot:head(actions)="data">
            <div class="text-nowrap">{{ data.label }}</div>
          </template>

          <!-- Cells -->
          <template v-slot:cell(type)="row">
            <div class="fs-13">
              {{ (row.item.type === 'Assignment') ? 'Unknown Slides Assignment' :(row.item.type === 'Collection' && row.item.slideCollectionType) ? (row.item.slideCollectionType === 'VIEW_HIDE_DIAGNOSIS') ? 'Slide Collection: View/Hide Diagnosis' :  `Slide Collection: Diagnosis Shown` : row.item.type }}
            </div>
          </template>
          <template v-slot:cell(idNumber)="row">
            <div class="fs-13">
              {{ row.item.systemIdNumber }}
            </div>
          </template>
          <template v-slot:cell(tumorSite)="row">
            <div class="fs-13">
              {{ row.item.tumorSite || "N/A" }}
            </div>
          </template>
          <template v-slot:cell(title)="row">
            <div class="fs-13">
              {{ row.item.title }}
            </div>
          </template>
          <template v-slot:cell(difficultyLevel)="row">
            <div class="fs-13">
              {{ row.item.difficultyLevel.replace(/_/g, " ") }}
            </div>
          </template>
          <template v-slot:cell(createdDateTime)="row">
            <div class="fs-13">
              {{ new Date(row.item.createdDate).toLocaleDateString() }}
            </div>
          </template>
          <template v-slot:cell(authors)="row">
            <div class="fs-13">
              {{ row.item.author.replace(/_/g, " ") }}
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <table-actions
              :key="row.item.id"
              :material="row.item"
              :viewIcon="{ show: 'View' }"
              :shareIcon="
                currentFolder &&
                currentFolder.folderType === 'EDUCATIONALPUBLIC'
                  ? { show: 'Share' }
                  : { show: false }
              "
              :editIcon="
                currentFolder &&
                (currentFolder.folderType === 'EDUCATIONALOTHER' ||
                  currentFolder.folderType === 'EDUCATIONAL')
                  ? { show: 'Edit' }
                  : { show: false }
              "
              :deleteIcon="
                currentFolder &&
                (currentFolder.folderType === 'EDUCATIONALOTHER' ||
                  currentFolder.folderType === 'EDUCATIONAL')
                  ? { show: 'Delete' }
                  : { show: false }
              "
              :caseInformationIcon="{ show: 'Show Description' }"
              :moveToSlideLibraryIcon="
                currentFolder &&
                (currentFolder.folderType === 'EDUCATIONALOTHER' ||
                  currentFolder.folderType === 'EDUCATIONAL')
                  ? { show: 'Move to Public Access box' }
                  : { show: false }
              "
              :moveBackForRevisionIcon="
                currentFolder &&
                currentFolder.folderType === 'EDUCATIONALPUBLIC'
                  ? { show: 'Move Back to Creation Folder' }
                  : { show: false }
              "
              @view="viewMaterialInfo(row.item)"
              @edit="editItem(row.item)"
              @delete="deleteItem(row.item)"
              @moveBackForRevision="moveBacktoUserFolder(row.item)"
              @caseInformation="showCaseDescription(row.item)"
              @moveToSlideLibrary="moveToPublicbox(row.item)"
              @share="(event) => onShareButtonClick(event, row.item)"
            ></table-actions>
          </template>
        </b-table>
      </template>
      <template v-slot:empty>
        <tr>
          <td :colspan="tableFields.length" class="text-center py-5">
            <div class="text-muted">
              <i class="fas fa-inbox fa-2x mb-2"></i>
              <h5>No educational materials found</h5>
              <p class="mb-0">
                Try adjusting your filters or creating a new item
              </p>
            </div>
          </td>
        </tr>
      </template>
    </wtr-educational-material-list>

    <educational-material-add
      :editId="selectedEditId"
      :type="selectedType"
      :selectedUserId="selectedUserId"
      :currentFolder="currentFolder"
      :tumorSites="tumorSites"
      @saved="handleMaterialSaved"
    />

    <edu-material-copy  :systemIdNumber="systemIdNumber" :creationId="creationId"
  :show="showCopyModal" @closed="handleCopyModalClosed"/>

    <b-modal
      id="create-type-modal"
      title="Create Educational Material"
      hide-footer
    >
      <div class="d-flex flex-column align-items-center">
        <b-button
          block
          variant="primary"
          class="mb-2 btn-primary px-4 rounded-pill"
          @click="proceedToForm('Collection')"
        >
          Tumor Case Collection
        </b-button>

        <b-button
          block
          variant="primary"
          class="mb-2 btn-primary px-4 rounded-pill"
          @click="proceedToForm('Assignment')"
        >
          Assignment
        </b-button>
      </div>

      <div class="text-right mt-3">
        <b-button
          variant="secondary"
          @click="$bvModal.hide('create-type-modal')"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
    <b-modal id="show-description-modal" title="Description" hide-footer>
      <div v-if="selectedRow" class="d-flex flex-column align-items-center">
        <p class="mb-3">
          {{ selectedRow.description || "No description available" }}
        </p>
      </div>
    </b-modal>
    <div class="share-popover-container" style="position: fixed; z-index: 1001">
      <div
        class="edit-case-menu shadow-toolbar"
        v-if="sharePopover.show"
        :style="{
          top: sharePopover.y,
          left: sharePopover.x,
          position: 'fixed',
          display: 'block',
          width: '200px',
          height: '100px',
        }"
        @click.stop
      >
        <div class="popover-content text-center position-relative">
          <div class="toolbar-close-icon" @click="closeSharePopover">
            <svg
              id="Icon_ionic-md-close-circle-outline"
              data-name="Icon ionic-md-close-circle-outline"
              xmlns="http://www.w3.org/2000/svg"
              width="16.062"
              height="16.062"
              viewBox="0 0 16.062 16.062"
            >
              <path
                id="Path_10189"
                data-name="Path 10189"
                d="M11.406,5A6.406,6.406,0,1,1,6.873,6.873,6.383,6.383,0,0,1,11.406,5m0-1.622a8.031,8.031,0,1,0,8.031,8.031,8.03,8.03,0,0,0-8.031-8.031Z"
                transform="translate(-3.375 -3.375)"
                fill="#204c90"
              />
              <path
                id="Path_10190"
                data-name="Path 10190"
                d="M18.718,17.595l-1.124,1.124L14.7,15.826l-2.892,2.892-1.124-1.124L13.579,14.7l-2.892-2.892,1.124-1.124L14.7,13.579l2.892-2.892,1.124,1.124L15.826,14.7Z"
                transform="translate(-6.672 -6.672)"
                fill="#204c90"
              />
            </svg>
          </div>
          <div class="d-flex flex-column">
            <b-btn
              class="m-1 text-nowrap btn-rounded"
              variant="primary"
              size="sm"
              @click="shareMaterial('qr')"
            >
              Generate QR code
            </b-btn>
            <b-btn
              class="m-1 text-nowrap btn-rounded"
              variant="primary"
              size="sm"
              @click="shareMaterial('link')"
            >
              Copy link
            </b-btn>
          </div>
        </div>
      </div>
    </div>
    <canvas ref="qrCanvas" style="display: none"></canvas>
  </div>
</template>
<script>
// Components
import WTREducationalMaterialListComponent from "../../../components/common/wtr-educational-material-list.vue";
import EducationalMaterialAdd from "../components/add-educational-material.vue";
import TableActionsComponent from "../../../components/common/table-actions.vue";
import MaterialCopyComponent from "../../../components/common/edu-material-copy.vue";
// Constants
import * as folderTypes from "../../../constants/constants-folder";
import { mapActions } from "vuex";
import * as roleTypes from "../../../constants/constants-role";
import QRCode from "qrcode";
import _ from "lodash";

export default {
  name: "educational-material-box",
  data() {
    return {
      ...folderTypes,
      ...roleTypes,
      tumorSiteId: null,
      educationalMaterials: [],
      gridMode: false,
      paginationParams: {
        page: 0,
        size: 10,
        sort: "createdDate,desc",
        sortDesc:true,
      },
      totalMaterials: 0,
      loading: false,
      initialLoading: true,
      userDetail: null,
      selectedType: null,
      selectedEditId: null,
      selectedUserId: null,
      tumorSites: [],
      currentFilters: {
        search: "",
        slideCollectionType: "",
        level: "",
        tumorSiteId: null,
        isRecommended: null,
      },
      activeFolder: null, // keep track of active folder
      description: null,
      selectedRow: null,
      geographicRegions: [],
      sharePopover: {
        show: false,
        x: "",
        y: "",
      },
      selectedMaterial: null,
      systemIdNumber: null,
      showCopyModal: false,
      creationId: null,
      configSubFilters: [
        { 
          optionLabel: 'name', 
          optionValue: 'id', 
          placeholder: 'Learning Modality', 
          searchParam: 'slideCollectionType' 
        },
        { 
          optionLabel: 'name', 
          optionValue: 'id', 
          placeholder: 'Tumor Site', 
          searchParam: 'tumorSiteId' 
        },
        { 
          optionLabel: 'name', 
          optionValue: 'id', 
          placeholder: 'Difficulty Level', 
          searchParam: 'level' 
        },
        { 
          optionLabel: 'name', 
          optionValue: 'id', 
          placeholder: 'Recommended By', 
          searchParam: 'isRecommended' 
        }
      ],
      subFilters: [[], [], [], []],
      indexTumorSiteId: 1,
      indexDifficultyLevel: 2,
      indexLearningModality: 0,
      indexRecommendedBy: 3,
    };
  },
  components: {
    "wtr-educational-material-list": WTREducationalMaterialListComponent,
    "educational-material-add": EducationalMaterialAdd,
    "table-actions": TableActionsComponent,
    "edu-material-copy": MaterialCopyComponent,
  },
  props: {
    currentFolder: {
      type: Object,
      default: null,
    },
  },
  watch: {
    currentFolder: {
      handler(newFolder) {
        if (newFolder && !this.initialLoading) {
          this.activeFolder = newFolder;
          this.fetchFolderMaterials(newFolder);
        }
      },
      immediate: false,
    },
    tumorSites: {
      handler(newTumorSites) {
        // Update subFilters when tumorSites changes
        if (newTumorSites && newTumorSites.length > 0) {
          this.subFilters[this.indexTumorSiteId] = [...newTumorSites];
        }
      },
      immediate: true,
      deep: true
    }
  },
  async mounted() {
    window.addEventListener("click", this.closeSharePopover);
    await this.initializeData();
    this.initializeFilters();
  },
  beforeDestroy() {
    window.removeEventListener("click", this.closeSharePopover);
  },
  computed: {
    tableFields() {
      return [
        { key: "type", label: this.$t("Learning Modality") },
        { key: "idNumber", label: this.$t("ID") },
        { key: "tumorSite", label: this.$t("Tumor Site") },
        { key: "title", label: this.$t("Title") },
        { key: "difficultyLevel", label: this.$t("Difficulty Level") },
        { key: "createdDateTime", label: this.$t("Date of Creation") },
        { key: "authors", label: this.$t("Authors") },
        { key: "actions", label: this.$t("Actions") },
      ];
    },
    hasActiveFilters() {
      return !!(
        this.currentFilters.search ||
        this.currentFilters.slideCollectionType ||
        this.currentFilters.level ||
        this.currentFilters.tumorSiteId ||
        this.currentFilters.isRecommended
      );
    },
    staticDifficultyLevels() {
      return [
        { id: "Junior_Residents", name: "Junior Residents" },
        { id: "Pathology_Fellows", name: "Pathology Fellows" },
        { id: "Practicing_Pathologist", name: "Practicing Pathologist" },
        { id: "Mixed", name: "Mixed" },
        { id: "NA", name: "NA" },
      ];
    },
    staticLearningModalities() {
      return [
        { name: "All", id: "all" },
        { name: "Slide Collection: Diagnosis Shown", id: "DIAGNOSIS_SHOWN" },
        { name: "Slide Collection: View/Hide Diagnosis", id: "VIEW_HIDE_DIAGNOSIS" },
        { name: "Unknown Slides Assignment", id: "UNKNOWN_SLIDES_ASSIGNMENT" },
      ];
    },
    staticRecommendedBy() {
      return [
        { id: 1, name: "Recommended By WTR" },
        { id: 0, name: "Created By WTR User" },
      ];
    },
  },
  methods: {
    ...mapActions(["setSelectedCaseSlideIds"]),

    initializeFilters() {
      // Initialize static filters
      this.subFilters[this.indexDifficultyLevel] = this.staticDifficultyLevels;
      this.subFilters[this.indexLearningModality] = this.staticLearningModalities;
      this.subFilters[this.indexRecommendedBy] = this.staticRecommendedBy;
    },
    async initializeData() {
      try {
        const storedTumorSites = localStorage.getItem('tumorSites');
        if (storedTumorSites) {
          this.tumorSites = JSON.parse(storedTumorSites);
        } else {
          await this.getUserDetails();
        }

        this.initialLoading = false;

        if (this.currentFolder) {
          await this.fetchFolderMaterials(this.currentFolder);
        }
      } catch (error) {
        console.error("Error initializing data:", error);
        this.initialLoading = false;
        this.$handleError(error);
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    openTypeSelector() {
      this.$bvModal.show("create-type-modal");
    },
    proceedToForm(type) {
      this.selectedType = type;
      this.selectedEditId = null;
      this.selectedUserId = null;
      this.$bvModal.hide("create-type-modal");
      this.$bvModal.show("create-material-modal");
    },
    handleMaterialSaved() {
      this.$bvModal.hide("create-material-modal");
      this.$emit("material-saved");
      if (this.currentFolder) {
        this.fetchFolderMaterials(this.currentFolder);
      }
    },

   handleSort(sortField) {
  // Extract current sort field if exists
  const currentSortField = this.paginationParams.sort.split(',')[0];
  
  // If clicking the same field, toggle direction
  if (currentSortField === sortField) {
    // Toggle the sortDesc boolean
    this.paginationParams.sortDesc = !this.paginationParams.sortDesc;
  } else {
    // New field, default to ascending (false)
    this.paginationParams.sortDesc = false;
  }
  
  // Build the sort string based on sortDesc
  const direction = this.paginationParams.sortDesc ? 'desc' : 'asc';
  this.paginationParams.sort = `${sortField},${direction}`;

  // Reset to first page when sorting
  this.paginationParams.page = 0;

  // Fetch sorted data
  if (this.currentFolder) {
    this.fetchFolderMaterials(this.currentFolder);
  }
},

    async getAllMetadataList(tumorSiteId) {
      try {
        const response = await this.$api.getAllMetadataListFact(tumorSiteId);
        const allDataList = response.data.payload;
        if (allDataList != null) {
          this.tumorSites = allDataList.tumorSites;
        }
        return allDataList;
      } catch (error) {
        this.$handleError(error);
        throw error;
      }
    },

    async getUserDetails() {
      try {
        const response = await this.$api.getUserDetailFact(
          localStorage.getItem("userId")
        );
        this.userDetail = response.data;

        if (this.userDetail?.userTumorSites) {
          this.tumorSiteId = this.userDetail.userTumorSites.id;
          await this.getAllMetadataList(this.tumorSiteId);
        } else {
          this.tumorSiteId = null;
        }

        return this.userDetail;
      } catch (error) {
        this.$handleError(error);
        throw error;
      }
    },

    async fetchFolderMaterials(folder) {
      await this.sleep(100);
      if (this.initialLoading) return;

      this.loading = true;
      this.activeFolder = folder;
      try {
        const queryParams = {
          page: this.paginationParams.page,
          size: this.paginationParams.size,
          sort: this.paginationParams.sort,
          sortDirection: this.paginationParams.sortDesc ? "desc" : "asc",
        };
        const body = {
          userId: folder.userId || localStorage.getItem("userId"),
          isPublished: folder.folderType === "EDUCATIONALPUBLIC" ? 1 : 0,
          ...this.currentFilters,
        };

        // remove empty/null values
        Object.keys(body).forEach((key) => {
          if (
            body[key] === null ||
            body[key] === "" ||
            body[key] === undefined
          ) {
            delete body[key];
          }
        });

        const response = await this.$api.getMaterialByFolder(queryParams, body);
        if (this.$handleResponse(response)) {
          const payload = response.data.payload;
          this.educationalMaterials = payload?.content || [];
          this.totalMaterials =
            payload?.totalElements || this.educationalMaterials.length;
          this.$emit("folder-changed");
        }
      } catch (error) {
        this.$handleError(error);
        this.educationalMaterials = [];
        this.totalMaterials = 0;
      } finally {
        this.loading = false;
      }
    },

    handleGridModeChange(mode) {
      this.gridMode = mode;
    },
    handleSizeChange(params) {
      this.paginationParams.size = params.size;
      this.paginationParams.page = 0;
      if (this.currentFolder && !this.initialLoading) {
        this.fetchFolderMaterials(this.currentFolder);
      }
    },
    handlePageChange(params) {
      this.paginationParams.page = params.page;
      if (this.currentFolder && !this.initialLoading) {
        this.fetchFolderMaterials(this.currentFolder);
      }
    },
    handleFilterChange(newFilters) {
      if (Object.keys(newFilters).length === 0) {
    this.currentFilters = {
      search: "",
      slideCollectionType: "",
      level: "",
      tumorSiteId: null,
      isRecommended: null,
    };
  } else {
    this.currentFilters = {
      ...this.currentFilters,
      ...newFilters,
    };
  }
      
      this.paginationParams.page = 0;
      if (this.currentFolder && !this.initialLoading) {
        this.fetchFolderMaterials(this.currentFolder);
      }
    },

    async viewMaterialInfo(eduMaterial) {
      console.log("Viewing material:", eduMaterial);
      var query;
      var isPublicSite =
        this.currentFolder.folderType === "EDUCATIONALPUBLIC" ? true : false;
      const route = "edu-case-viewer";
      this.$changeRouteToTab({
        name: route,
        params: {
          id: eduMaterial.id,
          isPublicSite,
          tumorSiteId: localStorage.getItem("tumorSiteId") || 1,
          tumorSiteName: eduMaterial.tumorSite,
          type: eduMaterial.type,
          backToPublicSite: false,
          activeTab: 'none'
        },
        query: query ? query.query : null,
      });
    },
    editItem(item) {
      this.selectedEditId = item.id;
      this.selectedType = item.type;
      this.selectedUserId = item.author;
      this.$bvModal.show("create-material-modal");
    },
    showCaseDescription(item) {
      this.description = item.description;
      this.selectedRow = item;
      this.$bvModal.show("show-description-modal");
    },
    async moveToPublicbox(item) {
      this.$deleteConfirmation(
        `Are you sure you want to move material "${item.title}" to published folder?`,
        async () => {
          try {
            // build payload with the item id
            const payload = {
              ids: [item.id], // can also push multiple ids if you support multi-select
            };

            const response = await this.$api.moveToPublicbox(payload);
            const resData = response.data || response;
            if (resData.status == true) {
              if (item.systemIdNumber == item.idNumber) {
                this.systemIdNumber = resData.payload;
                this.creationId = item.idNumber;
                this.showCopyModal = true;
              }
              this.$toastr(
                "success",
                "Material moved to published folder successfully"
              );
              this.fetchFolderMaterials(this.currentFolder);
            } else {
              throw new Error("Failed to move material");
            }
          } catch (error) {
            this.$handleError(error);
          }
        }
      );
    },
    handleCopyModalClosed() {
      this.showCopyModal = false;
      this.selectedMaterial = null;
      this.systemIdNumber = null;
    },
    async moveBacktoUserFolder(item) {
      this.$deleteConfirmation(
        `Are you sure you want to move material "${item.title}" for revision?`,
        async () => {
          try {
            // build payload with the item id
            const payload = {
              ids: [item.id], // can also push multiple ids if you support multi-select
            };

            const response = await this.$api.moveToUserFolder(payload);
            const resData = response.data || response; // axios usually wraps in .data

            if (resData.status == true) {
              this.$toastr(
                "success",
                "Material moved back to user folder successfully"
              );

              this.fetchFolderMaterials(this.currentFolder);
            } else {
              throw new Error("Failed to move material");
            }
          } catch (error) {
            this.$handleError(error);
          }
        }
      );
    },
    deleteItem(item) {
      this.$deleteConfirmation(
        `Are you sure you want to delete "${item.title}"?`,
        async () => {
          try {
            const response = await this.$api.deleteEducationalMaterial(item.id);
            if (response.data.statusMessage !== "Success") {
              throw new Error("Failed to delete material");
            }
            this.$toastr("success", "Material deleted successfully");
            if (this.currentFolder) {
              this.fetchFolderMaterials(this.currentFolder);
            }
          } catch (error) {
            this.$handleError(error);
          }
        }
      );
    },
    onShareButtonClick(event, material) {
      if (!event) {
        console.error("Event is undefined!");
        return;
      }
      this.selectedMaterial = material;

      if (this.$userAgent.isMobile) {
        this.sharePopover = {
          show: true,
          x: "10px",
          y: "10px",
        };
      } else {
        // const clickedElement = event.target.closest("a"); // Find the share link
        const rect = event.getBoundingClientRect();
        console.log("Clicked element rect:", rect);
        const popoverWidth = 200;
        // Position relative to the clicked element
        const x = rect.right - popoverWidth; // Center horizontally on the icon
        const y = rect.bottom + 5; // Just below the icon

        console.log("Positioning popover at:", { x, y, rect });

        this.sharePopover = {
          show: true,
          x: `${x}px`,
          y: `${y}px`,
        };
      }
    },

    closeSharePopover() {
      this.sharePopover = {
        show: false,
        x: "",
        y: "",
      };
    },

    async shareMaterial(type) {
      this.closeSharePopover();

      if (!this.selectedMaterial) return;

      const material = this.selectedMaterial;
      const isPublicSite = true; // Always true for sharing
      const backToPublicSite = false;
      const params = {
        id: material.id,
        isPublicSite: isPublicSite,
        tumorSiteId: localStorage.getItem("tumorSiteId") || 1,
        tumorSiteName: material.tumorSite,
        type: material.type,
        backToPublicSite: backToPublicSite,
        activeTab: 'none'
      };

      const encryptedParams = _.mapValues(params, (value) =>
        this.$encryptData(value != null ? value : "")
      );

      const encryptedShareUrl = `${encryptedParams.id}/${encryptedParams.isPublicSite}/${encryptedParams.tumorSiteId}/${encryptedParams.type}/${encryptedParams.backToPublicSite}/${encryptedParams.activeTab}/${encryptedParams.tumorSiteName}`;

      try {
        const response = await this.$api.postCaseUrl({
          encryptedData: encryptedShareUrl,
        });
        if (response && response.data.id) {
          const shortUrl = `${window.location.origin}/edu-short-links/${response.data.id}`;

          if (type === "qr") {
            const canvas = this.$refs.qrCanvas;
            await QRCode.toCanvas(canvas, shortUrl, { width: 300 });
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            const fileName = `${
              material.systemIdNumber || material.idNumber
            }.png`;
            link.download = fileName;
            link.click();
          } else {
            navigator.clipboard
              .writeText(shortUrl)
              .then(() => {
                this.$toastr("success", "Copied to clipboard");
              })
              .catch((err) => {
                this.$toastr("error", `Failed to copy - ${err}`);
              });
          }
        }
      } catch (error) {
        console.error("Failed to create short link:", error);
        this.$toastr("error", "Failed to generate share link");
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.card-body {
  img {
    pointer-events: none;
  }
  padding: 0px;
}

.card-footer {
  padding: 0px;
  text-align: center;
}

.folder-card:hover {
  -webkit-box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.btn-file {
  position: relative;
  overflow: hidden;

  input {
    position: absolute;
    cursor: pointer;
    font-size: 50px;
    opacity: 0;
    right: 0;
    top: 0;
  }
}

.fs-13 {
  font-size: 13px !important;
}

.slide-name {
  width: 150px;
  word-break: break-all;
}

// Animation for grid/list transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.share-popover-container .edit-case-menu {
  position: absolute; /* Important */
}
</style>
